import { render, staticRenderFns } from "./priSettingsGeneralPage.vue?vue&type=template&id=6ad1e478"
import script from "./priSettingsGeneralPage.vue?vue&type=script&lang=js"
export * from "./priSettingsGeneralPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports